import { createAsyncThunk } from '@reduxjs/toolkit';

import { NewsService } from 'api';

import { MarkNewsItemProps } from 'models';

export const markAsUnread = createAsyncThunk(
	'news/markAsUnread',
	async (params: MarkNewsItemProps) => {
		return await NewsService.markAsUnread(params);
	},
);
